import type { ActionPlan } from "./types"

/**
 * Die Plan-Abfrage des Reviews — EINE Definition fuer ReviewCard und die
 * Review-Seite (#158). Die Seite stoesst sie an, sobald die Mail-ID feststeht,
 * also parallel zum Detail statt erst danach: vorher lief Liste → Detail →
 * Plan streng nacheinander. Gleicher Schluessel + gleiche `staleTime` =
 * React Query fragt nur einmal.
 */
export function planAbfrage(emailId: number) {
  return {
    queryKey: ["draft-plan", emailId] as const,
    queryFn: async (): Promise<ActionPlan> => {
      const r = await fetch(`/api/v1/drafts/${emailId}/plan`, { credentials: "include" })
      if (!r.ok) throw new Error(`HTTP ${r.status}`)
      return r.json()
    },
    staleTime: 1000 * 60 * 5,
  }
}
